<button color="primary" mat-flat-button [matMenuTriggerFor]="langMenu">
  <div class="" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
    <img [src]="'../../../assets/icons/' + currentLanguageItem.flag" alt="" />
    <span> {{ currentLanguageItem.title | translate }}</span>
    <img src="../../../assets/icons/ic_arrow_down_white.svg" alt="" />
  </div>
</button>

<mat-menu #langMenu="matMenu">
    <button mat-menu-item *ngFor="let languageItem of filteredLanguageList" (click)="setLanguage(languageItem)">
    {{ languageItem.title | translate }}
  </button>
</mat-menu>